import React from 'react';
import { Button } from '@/components/ui/button';
import { Link as ReactRouterLink } from 'react-router-dom';
import { Edit, Trash2, Check } from 'lucide-react';

interface TramiteActionsProps {
  tramite: any;
  onEliminar: () => void;
  onFinalizar: () => void;
  loadingEliminar?: boolean;
  loadingFinalizar?: boolean;
}

const TramiteActions: React.FC<TramiteActionsProps> = ({
  tramite,
  onEliminar,
  onFinalizar,
  loadingEliminar = false,
  loadingFinalizar = false
}) => {
  return (
    <div className="flex flex-col sm:flex-row gap-3 pt-8 justify-center items-center">
      <Button
        variant="outline"
        className='border-red-600 text-red-600 hover:bg-red-50 hover:border-red-400 transition-colors duration-200 min-w-[140px]'
        onClick={onEliminar}
        loading={loadingEliminar}
        size='sm'
      >
        <Trash2 className="w-4 h-4 mr-2" />
        Eliminar trámite
      </Button>

      <Button
        variant="outline"
        className="text-orange-600 border-orange-300 hover:bg-orange-50 hover:border-orange-400 transition-colors duration-200 min-w-[140px]"
        asChild
        size='sm'
      >
        <ReactRouterLink
          to="/tramite"
          state={{ tramite }}
        >
          <Edit className="w-4 h-4 mr-2" />
          Editar trámite
        </ReactRouterLink>
      </Button>

      <Button
        variant="outline"
        onClick={onFinalizar}
        className='text-green-600 border-green-300 hover:bg-green-50 hover:border-green-400 transition-colors duration-200 min-w-[140px]'
        loading={loadingFinalizar}
        size='sm'
      >
        <Check className="w-4 h-4 mr-2" />
        Finalizar trámite
      </Button>
    </div>
  );
};

export default TramiteActions;
